/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Order_Payment_Method_Change_DescriptionInputs */

const vi_order_payment_method_change_description = /** @type {(inputs: Order_Payment_Method_Change_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khoản ${i?.amount} đang ghi là ${i?.from}. Đổi sang ${i?.to}? Số tiền và trạng thái đơn giữ nguyên, Báo cáo thu chi sẽ tính khoản này theo hình thức mới.`)
};

/**

* @param {Order_Payment_Method_Change_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_description = /** @type {((inputs: Order_Payment_Method_Change_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_description(inputs)
});